import React from 'react';
import './case-study-hero.css';
import CaseStudySearch from '../case-study-search';

const CaseStudyHero: React.FC<{ onSearch: (query: string) => void }> = ({ onSearch }) => {
    return (
        <section className="hero-section blog-hero-section">
            <div className="container">
                <div className="blog-hero-wrapper">
                    <h1 className="text-3xl bold teal animate blog-h1">Case Studies</h1>
                    <p className='text-lg text-black description animate'>Take a deeper dive into the future of AI in customer service with case studies.</p>
                    <div className='animate form-parent'>
                        <CaseStudySearch onSearch={onSearch} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CaseStudyHero;
